import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoComponent implements OnInit {
  @Input() tooltip: string;
  @Input() inline: boolean;

  constructor() {}

  ngOnInit(): void {}
}
